export const BASE_COLUMNS: string[] = [
  'site',
  'text',
  'voice',
  'email',
  'push',
  'coachingText',
  'coachingVoice',
  'coachingEmail',
  'coachingPush',
  'offer',
  'performance',
  'paymentEmail',
  'paymentPush',
  'reminderEmail',
  'reminderPush',
  'alertRuleEmail',
];
export type BaseColumn = (typeof BASE_COLUMNS)[number];
